export default __webpack_public_path__ + "assets/front/scss/common.288f3637967a7041371bc7580a7095a2.css";